// extracted by mini-css-extract-plugin
export default {"container":"Xo-z","bubbleNav":"Yo-z","graphic":"Zo-z","contact":"_o-z"};